export const envConfig = {
    auth: {
      clientId: 'c7e4907f-4ade-4da3-bd66-ba8bb2b8da2b',
      tenantId: '3d4a2968-1d95-4c51-bac6-8edac6ce1d49'
    },
    api: {
      baseUrl: 'https://apim-qes-germanywestcentral-authlayer.azure-api.net/api'
    }
  }
  